import { Stack, useTheme, useMediaQuery, Box, Typography } from "@mui/material";
import { Icons } from "../../assets/icon";
import "./AboutMe.scss";

export function AboutMe({
  bio,
  portfolioLinks,
  socialMedia,
}: {
  bio: string;
  portfolioLinks?: string[];
  socialMedia?: { facebook?: string; tiktok?: string; instagram?: string; youtube?: string };
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ width: "100%" }}>
      <div className="about-me">
        <Typography variant="h6" sx={{ 
          fontSize: isMobile ? "16px" : "18px",
          lineHeight: isMobile ? "20px" : "24px",
          fontWeight: 600
        }}>
          Bio
        </Typography>
        <p className={isMobile ? "mobile" : ""}>{bio}</p>
      </div>
      {portfolioLinks && portfolioLinks.length > 0 && (
        <div className="about-me">
          <Typography variant="h6" sx={{ 
            fontSize: isMobile ? "16px" : "18px",
            lineHeight: isMobile ? "20px" : "24px",
            fontWeight: 600
          }}>
            Portfolio Link
          </Typography>
          <Stack 
            direction="column"
            spacing={isMobile ? 1 : 2}
            sx={{ 
              marginTop: isMobile ? "12px" : "16px", 
              marginBottom: isMobile ? "12px" : "16px",
              flexWrap: "wrap",
              width: "100%"
            }}
          >
            {portfolioLinks.map((link) => (
              <a 
                href={link} 
                target="_blank" 
                rel="noopener noreferrer" 
                key={link}
                className="portfolio-link"
                style={{
                  fontSize: isMobile ? "14px" : "16px",
                }}
              >
                {link}
              </a>
            ))}
          </Stack>
        </div>
      )}
      {socialMedia && (
        <div className="about-me">
          <Typography variant="h6" sx={{ 
            fontSize: isMobile ? "16px" : "18px",
            lineHeight: isMobile ? "20px" : "24px",
            fontWeight: 600
          }}>
            Socials
          </Typography>
          <Stack 
            direction="row" 
            spacing={isMobile ? "12px" : "16px"} 
            sx={{ 
              marginTop: isMobile ? "12px" : "16px", 
              marginBottom: isMobile ? "12px" : "16px",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: isMobile ? "center" : "flex-start"
            }}
          >
            {socialMedia.facebook && (
              <a href={socialMedia.facebook} target="_blank" rel="noopener noreferrer">
                <Icons.Facebook width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} />
              </a>
            )}
            {socialMedia.tiktok && (
              <a href={socialMedia.tiktok} target="_blank" rel="noopener noreferrer">
                <Icons.Tiktok width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} />
              </a>
            )}
            {socialMedia.instagram && (
              <a href={socialMedia.instagram} target="_blank" rel="noopener noreferrer">
                <Icons.Instagram width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} />
              </a>
            )}
            {socialMedia.youtube && (
              <a href={socialMedia.youtube} target="_blank" rel="noopener noreferrer">
                <Icons.Youtube width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} />
              </a>
            )}
          </Stack>
        </div>
      )}
    </Box>
  );
}
